export { default } from './ProductsListTabs'
